import { JobStatusEnum, JobTypeEnum } from '../enums';

interface IJobCreatedByOutputDto {
    userId?: string;
    name: string;
}

export interface IJobOutputDto<T> {
    id?: string;
    organizationId: string;
    status?: JobStatusEnum;
    createdAt?: string;
    createdBy: IJobCreatedByOutputDto;
    data: T;
    type: JobTypeEnum;
}
